import React, { useEffect,useState } from "react";
import { Table } from "react-bootstrap";
import "./index.css";
import Vectoricon from '../../../../../assets/svg/Vector.svg'
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { RootState } from "@store/reducers";
import { useSelector } from "react-redux";
import { buttonNames } from "@constants/appConstants";
import { isServiceThroughSession } from "@utils/commonUtils";
import { decodeWithKeyAndShift } from "@utils/base64Utils";
import {  getData, postDataJSON } from "@services/CommonApiService";
import endpoints from "@config/endpoints";
import { ServiceReportCodeForChild } from "../ChildServices/NewBorn/NewBornForm/NewBornConstants";
import { errorLogger } from "@utils/applicationLogUtils";
import { useDispatch } from "react-redux";
import { updateChild } from "@store/actions/beneficiaryAction";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { benef_const } from "@constants/beneficiaryConstant";
import FormatDate from "@utils/dateFormat";
import { dateFormate } from "@constants/index";
import { calculateMaxDates } from "@utils/calculateMaxDatesForImmunization";


const ChildImmunizationTable = (props: any) => {
    const immunizationDates = props.dates
    const isDead=props.isDead
    const [immunizationData, setImmunizationData] = useState<any[]>([]);
    const [dateValues, setDateValues] = useState<string[]>([]);
    const [disabledFields, setDisabledFields] = useState<boolean[]>([]);
    const [serviceIds, setServiceIds] = useState<any>({});
    const eventExution = useSelector((state: RootState) => state.eventExution);
    const childData = useSelector((state: RootState) => state.beneficiary.childDetails);
    const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
    const vaccineDateUpdated = useSelector((state: RootState) => state.beneficiary.vaccineDateUpdated);
    const userId = localStorage.getItem('userId');
    const { id } = useParams()
    const vhndDetails = isServiceThroughSession(eventExution);
    const [pickerOpenIndex, setPickerOpenIndex] = useState<number | null>(null);
    const dispatch = useDispatch();
    const maxDates = calculateMaxDates(childData);
    const { opvMaxDate, bcgMaxDate, vitMaxDate, hepMaxDate } = maxDates;
    
    const handleDateChange = (value: any, index: number) => {
        const updatedDates = [...dateValues];
        updatedDates[index] = value ? dayjs(value).format(dateFormate.yyyy_mm_dd) : "";
        setDateValues(updatedDates);
    };

    const ageTodays = (age: string): number => {
        if (!age) return 0;
        const lower = age.toLowerCase().trim();
        if (lower === 'birth') return 0;
        const match = lower.match(/^(\d+)\s*(week|weeks|month|months|year|years)$/);
        if (!match) return 0;
        const value = parseInt(match[1]);
        const unit = match[2];
        if (unit.startsWith('week')) return value * 7;
        if (unit.startsWith('month')) return value * 30;
        if (unit.startsWith('year')) return value * 365;
        return 0;
    };

    const fetchImmunizationSchedule = async () => {
        try {
            const response = await getData<any>(`${endpoints.childImmunizationPeriod}`);
            
            if (response?.data) {
                const groupedByAge = response.data.reduce((acc: any, item: any) => {
                    const age = item.uwin_age_limit;
                    if (!acc[age]) {
                        acc[age] = {
                            age: age,
                            vaccinations: []
                        };
                    }
                    acc[age].vaccinations.push({
                        vaccinationName: item.service_name,
                        serviceCode: item.service_code,
                        serviceId: item.service_id,
                        vaccinationDate: null
                    });
                    return acc;
                }, {});
                
                const immunizationSchedule = (Object.values(groupedByAge) as any[])
                    .sort((a: any, b: any) => ageTodays(a.age) - ageTodays(b.age));
                
                setImmunizationData(immunizationSchedule);
                const totalVaccinations = immunizationSchedule.reduce((total: number, group: any) => 
                    total + group.vaccinations.length, 0);
                
                setDateValues(new Array(totalVaccinations).fill(""));
                setDisabledFields(new Array(totalVaccinations).fill(false));
            }
        } catch (error) {
            errorLogger(error);
            const scheduleData = (benef_const.immunizationTable as any[]).sort((a: any, b: any) => ageTodays(a.age) - ageTodays(b.age));
            setImmunizationData(scheduleData);
            
            const totalVaccinations = scheduleData.reduce((total: number, group: any) => 
                total + group.vaccinations.length, 0);
            
            setDateValues(new Array(totalVaccinations).fill(""));
            setDisabledFields(new Array(totalVaccinations).fill(false));
        }
    };


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (pickerOpenIndex !== null) {
                const datePickerElements = document.querySelectorAll(".ant-picker-dropdown");
                let clickedOutside = true;

                datePickerElements.forEach((picker) => {
                    if (picker.contains(event.target as Node)) {
                        clickedOutside = false;
                    }
                })
                if (clickedOutside) {
                    setPickerOpenIndex(null);
                    setDateValues((prevValues) => {
                        const updatedValues = [...prevValues];
                        updatedValues[pickerOpenIndex!] = "";
                        return updatedValues;
                    })
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [pickerOpenIndex]);

    useEffect(() => {
        fetchImmunizationSchedule();
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [opvData, hepData, vitkData, bcgData] = await Promise.all([
                    postDataJSON<any>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.opv0}),
                    postDataJSON<any>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.hepb0}),
                    postDataJSON<any>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.vitK}),
                    postDataJSON<any>(`${endpoints.fetchServiceReportForChild}`,{reportType:ServiceReportCodeForChild.bcg})
                ]);

                setServiceIds({
                    opv0: opvData.data[0]?.service_id,
                    hep: hepData.data[0]?.service_id,
                    vitk: vitkData.data[0]?.service_id,
                    bcg: bcgData.data[0]?.service_id
                });
            } catch (error) {
                errorLogger(error)
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        if (immunizationDates?.data && immunizationData.length > 0) {
            const updatedDates = [...dateValues];
            const updatedDisabledFields = [...disabledFields];
            
            let globalIndex = 0;
            
            immunizationData.forEach((ageGroup: any) => {
                ageGroup.vaccinations.forEach((vaccination: any) => {
                    const matchingDate = immunizationDates.data.find((item: any) => 
                        vaccination.serviceCode === item.service_code || 
                        vaccination.serviceId === item.service_id
                    );
                    
                    if (matchingDate && matchingDate.service_date) {
                        updatedDates[globalIndex] = dayjs(FormatDate(matchingDate.service_date)).format(dateFormate.yyyy_mm_dd);
                        updatedDisabledFields[globalIndex] = true;
                    }
                    globalIndex++;
                });
            });

            setDateValues(updatedDates);
            setDisabledFields(updatedDisabledFields);
        }
    }, [immunizationDates, immunizationData]);


    const handleSubmit = async () => {
        try {
            if (pickerOpenIndex === null) return;
            let globalIndex = 0;
            let currentItem = null;
            
            for (const ageGroup of immunizationData) {
                for (const vaccination of ageGroup.vaccinations) {
                    if (globalIndex === pickerOpenIndex) {
                        currentItem = vaccination;
                        break;
                    }
                    globalIndex++;
                }
                if (currentItem) break;
            }
            
            if (!currentItem) return;
            
            const serviceCode = currentItem.serviceCode;
            const serviceId = currentItem.serviceId;
            const formattedDate = dateValues[pickerOpenIndex] ? dayjs(dateValues[pickerOpenIndex]).format(dateFormate.yyyy_mm_dd) : '';
            
            const payload: any = {
                benefId: id,
                facilityId: userDetail?.facility_id,
                healthProviderId: userId,
                mobiliserId: null,
                sessionId: vhndDetails?.sessionId || null,
                executionId: vhndDetails?.executionId || null,
                visitDate: dayjs().format(dateFormate.yyyy_mm_dd),
                parentUserId: userId,
            };

            switch (serviceCode) {
                case 'opv0':
                case 'opv_0':
                    payload.opv0ServiceId = serviceIds?.opv0 || serviceId;
                    payload.opv0ServiceDate = formattedDate;
                    break;
                case 'hep_b_birth_dose':
                    payload.hepb0ServiceId = serviceIds?.hep || serviceId;
                    payload.hepb0ServiceDate = formattedDate;
                    break;
                case 'vit-k':
                    payload.vitkServiceId = serviceIds?.vitk || serviceId;
                    payload.vitkServiceDate = formattedDate;
                    break;
                case 'bcg':
                    payload.bcgServiceId = serviceIds?.bcg || serviceId;
                    payload.bcgServiceDate = formattedDate;
                    break;
                default:
                    payload[`${serviceCode}ServiceId`] = serviceId;
                    payload[`${serviceCode}ServiceDate`] = formattedDate;
                    break;
            }

            const response = await postDataJSON<any>(`${endpoints.childImmunization}`, payload);

            if (response?.data?.[0]) {
                setPickerOpenIndex(null);
                dispatch(updateChild("vaccineDateUpdated", !vaccineDateUpdated));
                setDisabledFields((prev) => {
                    const updatedFields = [...prev];
                    updatedFields[pickerOpenIndex!] = true;
                    return updatedFields;
                });
                toast.success(benef_const.vaccineDateUpdated, {
                    position: "top-center"
                });
            } else {
                toast.error(benef_const.somethingWentWrong, {
                    position: "top-center"
                });
            }
        } catch (error) {
            toast.error(benef_const.somethingWentWrong, {
                position: "top-center"
            });
        }
    };
    const minDate = dayjs(childData?.dob);
    
    const getValidPickerMonth = (rowIndex:any, childData:any, opvMaxDate:any, hepMaxDate:any, vitMaxDate:any, bcgMaxDate:any) => {
        const minDate = dayjs(childData?.dob);
        const rowSpecificRanges = [
            { minDate, maxDate: opvMaxDate },
            { minDate, maxDate: hepMaxDate },
            { minDate, maxDate: vitMaxDate },
            { minDate, maxDate: bcgMaxDate },
        ];
        const { minDate: rangeMinDate, maxDate } = rowSpecificRanges[rowIndex % 4] || rowSpecificRanges[0];
        return dayjs().startOf("month").isBefore(rangeMinDate) || dayjs().startOf("month").isAfter(maxDate) 
            ? rangeMinDate.startOf("month") 
            : dayjs().startOf("month");
    };
    
    return (
        <>
            <Table className="ChildImmunization-table table" responsive>
                <thead>
                    <tr>
                        <th>Age</th>
                        <th>Vaccination Name</th>
                        <th>Vaccination Date</th>
                    </tr>
                </thead>
                <tbody>
                    {immunizationData.map((ageGroup: any, ageIndex: number) => {
                        const minDate = dayjs(childData?.dob);
                        let globalIndex = 0;
                        for (let i = 0; i < ageIndex; i++) {
                            globalIndex += immunizationData[i].vaccinations.length;
                        }
                        
                        return ageGroup.vaccinations.map((vaccination: any, vacIndex: number) => {
                            const currentGlobalIndex = globalIndex + vacIndex;
                            const isFirstVaccination = vacIndex === 0;
                            const rowSpan = ageGroup.vaccinations.length;
                            
                            const serviceCode = vaccination.serviceCode;
                            let maxDate = opvMaxDate;
                            
                            switch (serviceCode) {
                                case 'opv0':
                                case 'opv_0':
                                    maxDate = opvMaxDate;
                                    break;
                                case 'hep_b_birth_dose':
                                    maxDate = hepMaxDate;
                                    break;
                                case 'vit-k':
                                    maxDate = vitMaxDate;
                                    break;
                                case 'bcg':
                                    maxDate = bcgMaxDate;
                                    break;
                                default:
                                    maxDate = opvMaxDate;
                            }

                            return (
                                <tr key={`${ageIndex}-${vacIndex}`}>
                                    {isFirstVaccination && (
                                        <td rowSpan={rowSpan}>{ageGroup.age}</td>
                                    )}
                                    <td style={{ padding: '10px' }}>{vaccination.vaccinationName}</td>
                                    <td className={`table-container ${(disabledFields[currentGlobalIndex] || isDead) ? 'disabled-cell' : ''}`} style={{ paddingLeft: '20px' }}>
                                        {dateValues[currentGlobalIndex] && disabledFields[currentGlobalIndex] ? (
                                            <span>{dayjs(dateValues[currentGlobalIndex]).format(dateFormate.dd_mm_yyyy)}</span>
                                        ) : dateValues[currentGlobalIndex] && !disabledFields[currentGlobalIndex] ? (
                                            <DatePicker
                                                format={dateFormate.dd_mm_yyyy}
                                                placeholder={dateFormate.dd_mm_yyyy}
                                                value={dateValues[currentGlobalIndex] ? dayjs(dateValues[currentGlobalIndex]) : undefined}
                                                onChange={(value) => handleDateChange(value, currentGlobalIndex)}
                                                className="vaccinationDate"
                                                showToday={false}
                                                popupClassName="date-picker-popup-child-immunization"
                                                suffixIcon={false}
                                                showTime={false}
                                                defaultPickerValue={getValidPickerMonth(currentGlobalIndex, childData, opvMaxDate, hepMaxDate, vitMaxDate, bcgMaxDate)}
                                                disabledDate={(current) => {
                                                    return current && (current.isBefore(minDate) || current.isAfter(maxDate));
                                                }}
                                                open={pickerOpenIndex === currentGlobalIndex}
                                                onOpenChange={(status) => setPickerOpenIndex(status ? currentGlobalIndex : pickerOpenIndex)}
                                                disabled={disabledFields[currentGlobalIndex] || isDead}
                                                allowClear={false}
                                                renderExtraFooter={() => (
                                                    <button
                                                        onClick={() => handleSubmit()}
                                                        disabled={!dateValues[currentGlobalIndex]}
                                                        className="adding_the_dynamic_button-primary"
                                                        type="button"
                                                    >
                                                        {buttonNames.submit}
                                                    </button>
                                                )}
                                            />
                                        ) : (
                                            <span>---</span>
                                        )}
                                    </td>
                                </tr>
                            );
                        });
                    })}
                </tbody>
            </Table>
        </>)
};

export default ChildImmunizationTable;
